import { useState } from 'react';
import { useSolanaLive } from './useSolanaLive';
import { buyCurrentGame as sendBuyCurrentGame } from '../solana/transactions/buyCurrentGame';
import { sellCurrentGame as sendSellCurrentGame } from '../solana/transactions/sellCurrentGame';

export function useTradeActions() {
  const {
    currentGamePubkey,
    currentGameState,
    dumpVaultPubkey,
    globalConfig,
    globalConfigPubkey,
  } = useSolanaLive();
  const [isBuying, setIsBuying] = useState(false);
  const [isSelling, setIsSelling] = useState(false);
  const [tradeError, setTradeError] = useState('');
  const [lastTradeSignature, setLastTradeSignature] = useState('');

  const buyCurrentGame = async (solAmount) => {
    setIsBuying(true);
    setTradeError('');
    setLastTradeSignature('');

    try {
      const signature = await sendBuyCurrentGame({
        solAmount,
        globalConfig,
        globalConfigPubkey,
        currentGameState,
        currentGamePubkey,
        dumpVaultPubkey,
      });

      setLastTradeSignature(signature);

      return signature;
    } catch (error) {
      const message = error?.message || 'Buy transaction failed.';
      setLastTradeSignature('');
      setTradeError(message);
      throw error;
    } finally {
      setIsBuying(false);
    }
  };

  const sellCurrentGame = async (tokenAmount, sellerTokenAta) => {
    setIsSelling(true);
    setTradeError('');
    setLastTradeSignature('');

    try {
      const signature = await sendSellCurrentGame({
        tokenAmount,
        globalConfig,
        globalConfigPubkey,
        currentGameState,
        currentGamePubkey,
        dumpVaultPubkey,
        sellerTokenAta,
      });

      setLastTradeSignature(signature);

      return signature;
    } catch (error) {
      const message = error?.message || 'Sell transaction failed.';
      setLastTradeSignature('');
      setTradeError(message);
      throw error;
    } finally {
      setIsSelling(false);
    }
  };

  return {
    buyCurrentGame,
    isBuying,
    sellCurrentGame,
    isSelling,
    tradeError,
    lastTradeSignature,
  };
}
